/**
 * Head-office contact details.
 *
 * ⚠️ The phone number below is still a PLACEHOLDER carried over from the design
 * mockup. The localised address lines live in the i18n bundles
 * (`contact.addressLine1` / `addressLine2`) because they differ per language;
 * everything here does not.
 *
 * `phoneHref` is deliberately `null` while the number is a placeholder: a
 * `tel:` link built from "XX XXX XXX" would look live and dial nothing. Set it
 * once the real number lands and the component turns it into a link.
 */
export const CONTACT = {
  email: 'info@chaleunxaymoungkhoun.com',
  emailHref: 'mailto:info@chaleunxaymoungkhoun.com',

  // TODO: replace with the real phone number, then set phoneHref to `tel:+856…`.
  phone: '+856 20 XX XXX XXX',
  phoneHref: null as string | null,

  website: 'www.chaleunxaymoungkhoun.com',
  websiteHref: 'https://www.chaleunxaymoungkhoun.com',

  // Head-office coordinates, 17.98343361412371 / 102.69129511083867.
  //
  // The trailing `(Label)` is what makes Google drop an actual red pin — `?q=`
  // with bare coordinates only recentres the map, and so does the older `pb=`
  // embed from the design mockup. This keyless form needs no Maps API key.
  mapEmbedUrl:
    'https://maps.google.com/maps?q=17.98343361412371,102.69129511083867(Chaleun+Xaymoungkhoun)&z=16&output=embed',
} as const
